import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '~/common/components/ui/dialog';
import { ScrollArea } from '~/common/components/ui/scroll-area';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '~/common/components/ui/accordion';
import {
  useWebshopMessages,
  WEBSHOPMESSAGE_TYPE_GENERAL,
  WEBSHOPMESSAGE_TYPE_AGH_IMPORTANT,
  WEBSHOPMESSAGE_TYPE_BGH_IMPORTANT
} from '~/features/webshopmessages/hooks/useWebshopMessages';
import { LucideInfo } from 'lucide-react';
import { cn } from '~/common/utils/styleUtil';

export function WebshopMessageDialog() {
  const { t } = useTranslation();
  const { isDialogOpen, setIsDialogOpen, messages } = useWebshopMessages();
  const [expandedItemId, setExpandedItemId] = useState<string | undefined>(messages?.[0]?.id.toString());

  return (
    <Dialog open={isDialogOpen} onOpenChange={() => setIsDialogOpen(false)}>
      <DialogContent className="p-0 flex flex-col gap-0" data-testid={'webshop-message-dialog'}>
        <DialogHeader className={'border-b px-4 pt-4'}>
          <DialogTitle className={'text-black/80'}>{t('Mitteilungen')}</DialogTitle>
          <DialogDescription hidden={true}>{t('Mitteilungen')}</DialogDescription>
        </DialogHeader>
        <div className="grow">
          <ScrollArea className="max-h-[calc(100vh-120px)] min-h-[300px] overflow-y-auto">
            <Accordion
              type="single"
              collapsible
              className="w-auto"
              value={expandedItemId}
              onValueChange={id => setExpandedItemId(id)}
            >
              {messages.map((message, index) => (
                <AccordionItem
                  key={message.id}
                  value={message.id.toString()}
                  className={cn('border-none', index % 2 === 0 ? 'bg-white' : 'bg-primary-light')}
                >
                  <AccordionTrigger className={'text-left text-lg hover:no-underline px-4 text-secondary'}>
                    <div className={'flex items-center'}>
                      <div className={'flex items-center mr-2'}>
                        <div
                          className={cn(
                            'rounded-full text-white p-1.5',
                            (message.type === WEBSHOPMESSAGE_TYPE_AGH_IMPORTANT ||
                              message.type === WEBSHOPMESSAGE_TYPE_BGH_IMPORTANT) &&
                              'bg-messages-important',
                            message.type === WEBSHOPMESSAGE_TYPE_GENERAL && 'bg-messages-general'
                          )}
                        >
                          <LucideInfo />
                        </div>
                      </div>
                      <div className={'font-bold text-base text-black/80'}>{message.title}</div>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className={'text-md text-black/70 px-4'}>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: message.message
                      }}
                    />
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </ScrollArea>
        </div>
      </DialogContent>
    </Dialog>
  );
}
